import { identity } from 'fp-ts/function';
import * as R from 'fp-ts/Record';
import { panic } from './invariant.js';
export * from 'fp-ts/struct';
export const evolvePartial = (transformations) => (a) => {
    const out = {};
    for (const k in a) {
        if (Object.prototype.hasOwnProperty.call(a, k)) {
            const transform = transformations[k] ?? identity;
            out[k] = transform(a[k]);
        }
    }
    return out;
};
export const renameKey = (ka, kb) => (a) => Object.fromEntries(Object.entries(a).map(([k, v]) => [k === ka ? kb : k, v]));
export const modifyAt = (k, f) => (a) => ({
    ...a,
    [k]: f(a[k]),
});
export const filterWithIndex = R.filterWithIndex;
export const entries = Object.entries;
export const distributivePick = (...args) => {
    if (args.length === 1)
        return (obj) => distributivePick(obj, args[0]);
    const result = {};
    const [obj, keys] = args;
    if (keys.length === 0)
        return result;
    keys.forEach((k) => {
        if (Object.prototype.hasOwnProperty.call(obj, k))
            result[k] = obj[k];
    });
    return result;
};
/**
 * Keep only the given keys of an object
 */
export const pick = distributivePick;
/**
 * Remove the given keys from an object
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function omit(...args) {
    if (args.length === 1)
        return (a) => omit(a, args[0]);
    const [obj, keys] = args;
    const pickedKeys = Object.keys(obj).filter((k) => !keys.includes(k));
    return pick(obj, pickedKeys);
}
/**
 * Obtain the value for a given key of an object
 */
export const get = (...args) => {
    if (args.length === 1)
        return (obj) => get(obj, args[0]);
    const [obj, key] = args;
    if (!Object.prototype.hasOwnProperty.call(obj, key)) {
        panic(`Key '${String(key)}' not found`);
    }
    return obj[key];
};
//# sourceMappingURL=struct.js.map